import { Navigate, useLocation } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'
import { useUser } from '../contexts/UserContext'
import { readIntendedUrl, saveIntendedUrl, clearIntendedUrl } from '../lib/intendedUrl'

export default function ProtectedRoute({ children, requireAdmin = false }) {
  const { user: authUser, loading: authLoading } = useAuth()
  const { user: userProfile, loading: userLoading } = useUser()
  const location = useLocation()

  // Show loading while auth or user profile is loading
  if (authLoading || userLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto mb-4"></div>
          <p className="text-muted-foreground">Loading...</p>
        </div>
      </div>
    )
  }

  // Not authenticated - save intended URL and redirect to login
  if (!authUser) {
    const skipPaths = ['/', '/login', '/register', '/home']
    if (!skipPaths.includes(location.pathname)) {
      saveIntendedUrl(location.pathname + location.search)
    }
    return <Navigate to="/login" replace />
  }

  // Admin gating — runs after auth + profile checks so we have userProfile.role.
  if (requireAdmin && userProfile?.role !== 'admin') {
    return <Navigate to="/home" replace />
  }

  // User is authenticated and profile is complete - clear intended URL if we've reached it
  const intendedUrl = readIntendedUrl()
  const currentPath = location.pathname + location.search
  if (intendedUrl && currentPath === intendedUrl) {
    clearIntendedUrl()
  }

  return children
}
